<template>
  <div class="product-report product-report--query-grid">
    <!-- 查询条件 -->
    <div class="product-report-query">
      <Row
        :gutter="20"
        class="query-conditions"
      >
        <Col
          v-show="queryFieldVisibility.date"
          :span="queryColSpan"
          class="query-item"
        >
          <DatePicker
            v-model="date"
            style="width: 100%"
            @change="handleDatePickerChange"
          />
        </Col>
        <Col
          v-show="queryFieldVisibility.budget_ids"
          :span="queryColSpan"
          class="query-item"
        >
          <div class="query-filter">
            <Select
              v-model="budget_ids_mode"
              class="query-filter__mode"
            >
              <Option
                v-for="item in filterModeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </Select>
            <Select
              v-model="budget_ids"
              class="query-filter__content"
              placeholder="输入聚合名称"
              clearable
              multiple
              filterable
              remote
              collapse-tags
              reserve-keyword
              :remote-method="handleSearchAggregations"
            >
              <Option
                v-for="item in aggregationsOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </Select>
          </div>
        </Col>

        <Col
          v-show="queryFieldVisibility.product_ids"
          :span="queryColSpan"
          class="query-item"
        >
          <div class="query-filter">
            <Select
              v-model="product_ids_mode"
              class="query-filter__mode"
            >
              <Option
                v-for="item in filterModeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </Select>
            <Select
              v-model="product_ids"
              class="query-filter__content"
              placeholder="输入产品名称"
              clearable
              multiple
              filterable
              remote
              collapse-tags
              reserve-keyword
              :remote-method="handleSearchProducts"
            >
              <Option
                v-for="item in productsOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </Select>
          </div>
        </Col>

        <Col
          v-show="queryFieldVisibility.sale_type"
          :span="queryColSpan"
          class="query-item"
        >
          <Select
            v-model="sale_type"
            placeholder="请选择预算类型"
            style="width: 100%;"
            clearable
          >
            <Option
              v-for="item in budgetOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </Select>
        </Col>

                <Col
          v-show="queryFieldVisibility.agent_ids"
          :span="queryColSpan"
          class="query-item"
        >
          <div class="query-filter">
            <Select
              v-model="agent_ids_mode"
              class="query-filter__mode"
            >
              <Option
                v-for="item in filterModeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </Select>
            <Select
              v-model="agent_ids"
              class="query-filter__content"
              placeholder="输入代理商ID/名称"
              clearable
              multiple
              filterable
              remote
              collapse-tags
              reserve-keyword
              :remote-method="handleSearchAgents"
            >
              <Option
                v-for="item in agentOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </Select>
          </div>
        </Col>

                <Col
          v-show="queryFieldVisibility.user_sub_agent_ids"
          :span="queryColSpan"
          class="query-item"
        >
          <div class="query-filter">
            <Select
              v-model="user_sub_agent_ids_mode"
              class="query-filter__mode"
            >
              <Option
                v-for="item in filterModeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </Select>
            <Select
              v-model="user_sub_agent_ids"
              class="query-filter__content"
              placeholder="输入子账户ID/名称"
              clearable
              multiple
              filterable
              remote
              collapse-tags
              reserve-keyword
              :remote-method="handleSearchSubAccounts"
            >
              <Option
                v-for="item in SubAccountOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </Select>
          </div>
        </Col>

        <Col
          v-show="queryFieldVisibility.account_ids"
          :span="queryColSpan"
          class="query-item"
        >
          <div class="query-filter">
            <Select
              v-model="account_ids_mode"
              class="query-filter__mode"
            >
              <Option
                v-for="item in filterModeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </Select>
            <Select
              v-model="account_ids"
              class="query-filter__content"
              placeholder="输入广告主账户ID/名称"
              clearable
              multiple
              filterable
              remote
              collapse-tags
              reserve-keyword
              :remote-method="handleSearchAccounts"
            >
              <Option
                v-for="item in accountOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </Select>
          </div>
        </Col>

        <Col
          v-show="queryFieldVisibility.sale_ids"
          :span="queryColSpan"
          class="query-item"
        >
          <div class="query-filter">
            <Select
              v-model="sale_ids_mode"
              class="query-filter__mode"
            >
              <Option
                v-for="item in filterModeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </Select>
            <Select
              v-model="sale_ids"
              class="query-filter__content"
              placeholder="输入销售名称/所属"
              clearable
              multiple
              filterable
              remote
              collapse-tags
              reserve-keyword
              :remote-method="handleSearchSales"
            >
              <Option
                v-for="item in salesOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </Select>
          </div>
        </Col>

        <Col
          v-show="queryFieldVisibility.product_series_ids"
          :span="queryColSpan"
          class="query-item"
        >
          <div class="query-filter">
            <Select
              v-model="product_series_ids_mode"
              class="query-filter__mode"
            >
              <Option
                v-for="item in filterModeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </Select>
            <Select
              v-model="product_series_ids"
              class="query-filter__content"
              placeholder="请选择产品系（KA产品）"
              clearable
              multiple
              filterable
              remote
              reserve-keyword
              collapse-tags
              :remote-method="handleSearchSeries"
            >
              <Option
                v-for="item in productSeriesOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </Select>
          </div>
        </Col>

        <Col
          v-show="queryFieldVisibility.new_series_id"
          :span="queryColSpan"
          class="query-item"
        >
          <div class="query-filter">
            <Select
              v-model="new_series_id_mode"
              class="query-filter__mode"
            >
              <Option
                v-for="item in filterModeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </Select>
            <Select
              v-model="new_series_id"
              class="query-filter__content"
              placeholder="请选择产品系"
              clearable
              multiple
              filterable
              remote
              reserve-keyword
              collapse-tags
              :remote-method="handleSearchSeriesAll"
            >
              <Option
                v-for="item in productSeriesAllOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </Select>
          </div>
        </Col>

        <Col
          v-show="queryFieldVisibility.customer_cate"
          :span="queryColSpan"
          class="query-item"
        >
          <Select
            v-model="customer_cate"
            placeholder="请选择客户类目"
            style="width: 100%;"
            clearable
          >
            <Option
              v-for="item in kaOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </Select>
        </Col>

        <Col
          v-show="queryFieldVisibility.task_ids"
          :span="queryColSpan"
          class="query-item"
        >
          <div class="query-filter">
            <Select
              v-model="task_ids_mode"
              class="query-filter__mode"
            >
              <Option
                v-for="item in filterModeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </Select>
            <Select
              v-model="task_ids"
              class="query-filter__content"
              placeholder="输入任务名称"
              clearable
              multiple
              filterable
              remote
              collapse-tags
              reserve-keyword
              :remote-method="handleSearchTasks"
            >
              <Option
                v-for="item in taskOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </Select>
          </div>
        </Col>


        <Col
          v-show="queryFieldVisibility.plan_action_type"
          :span="queryColSpan"
          class="query-item"
        >
          <Select
            v-model="plan_action_type"
            placeholder="请选择推广目标"
            class="comp"
            style="width: 100%;"
            clearable
          >
            <Option
              v-for="item in ActionTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </Select>
        </Col>

        <Col
          v-show="queryFieldVisibility.idea_type"
          :span="queryColSpan"
          class="query-item"
        >
          <Select
            v-model="idea_type"
            placeholder="请选择创意类型"
            class="comp"
            style="width: 100%;"
            clearable
          >
            <Option
              v-for="item in IdeaTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </Select>
        </Col>

        <!-- <Col
          v-show="queryFieldVisibility.slot_names"
          :span="queryColSpan"
          class="query-item"
        >
          <div class="query-filter">
            <Select
              v-model="slot_names_mode"
              class="query-filter__mode"
            >
              <Option
                v-for="item in filterModeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </Select>
            <Select
              v-model="slot_names"
              class="query-filter__content"
              placeholder="输入栏位名称"
              clearable
              multiple
              filterable
              remote
              collapse-tags
              reserve-keyword
              :remote-method="handleSearchSlotNames"
            >
              <Option
                v-for="item in slotNameOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </Select>
          </div>
        </Col> -->

        <Col
          v-show="queryFieldVisibility.is_rta"
          :span="queryColSpan"
          class="query-item"
        >
          <Select
            v-model="is_rta"
            placeholder="请选择是否RTA"
            style="width: 100%;"
            clearable
          >
            <Option
              v-for="item in IsRtaOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </Select>
        </Col>

        <Col
          v-show="queryFieldVisibility.charge_type"
          :span="queryColSpan"
          class="query-item"
        >
          <Select
            v-model="charge_type"
            class="comp"
            placeholder="请选择出价方式"
            style="width: 100%;"
            clearable
          >
            <Option
              v-for="item in BidTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </Select>
        </Col>

        <Col
          v-show="queryFieldVisibility.dimension"
          :span="queryColSpan"
          class="query-item"
        >
          <Select
            v-model="dimension"
            class="comp"
            placeholder="汇总方式"
            style="width: 100%;"
            @change="handleAggregatedTypeChange"
          >
            <Option
              v-for="item in dateOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :disabled="item.value === 'hour' && !hourUseable"
            />
          </Select>
        </Col>

        <Col
          :span="queryActionSpan"
          class="query-item query-item--actions"
        >
          <div class="query-buttons">
            <Button
              plain
              type="primary"
              @click="handleReset"
            >
              重置
            </Button>
            <Button
              type="primary"
              @click="handleSearchData"
            >
              查询
            </Button>
            <Button
              v-if="showQueryToggle"
              type="text"
              class="query-toggle"
              @click="toggleQueryExpand"
            >
              {{ queryExpanded ? '收起' : '展开' }}
              <i :class="queryExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
            </Button>
          </div>
        </Col>
      </Row>

      <!-- <span
        v-if="lastUpdateTime"
        class="product-report-lastUpdateTime"
      >
        最新更新时间：{{ lastUpdateTime }}
      </span> -->
    </div>

    <!-- 汇总数据 -->
    <!-- <div
      v-loading="summaryLoading"
      class="product-report-summary clearfix"
    >
      <DataCard
        v-for="item in summary"
        :key="item.key"
        class="product-report-card"
        :dataSource="item"
        @setting-click="handleDataCardSettingClick"
        @num-click="handleDataCardNumClick"
      />
    </div> -->

    <StopDay
      v-model="stopDays"
      :visible.sync="stopDayVisible"
      @confirm="handleStopDayConfirm"
    />

    <!-- 我的业绩 -->
    <div class="product-report-chart">
      <Title text="我的业绩" />

      <Tabs
        v-model="dimension"
        class="product-report-tabs"
        @tab-click="handleTabsClick"
      >
        <TabPane
          v-for="item in summary"
          :key="item.key"
          :label="item.name"
          :name="item.key"
        />
      </Tabs>

      <div class="product-report-tabs-header">
        <div>
          <span>展示指标：</span>
          <Select
            v-model="field"
            @change="handleFieldSelectChange"
          >
            <Option
              v-for="item in options"
              :key="item.key"
              :label="item.name"
              :value="item.key"
            />
          </Select>
        </div>

        <RadioGroup
          v-model="summaryType"
          @change="handleSummaryTypeChange"
        >
          <RadioButton label="all">汇总显示</RadioButton>
          <RadioButton label="top">TOP10聚合</RadioButton>
        </RadioGroup>
      </div>

      <div v-loading="chartLoading">
        <Chart
          :dataSource="rawChartData"
          :field="field"
          :type="summaryType"
        />
      </div>
    </div>

    <!-- 详细数据 -->
    <div class="product-report-detail">
      <Title text="详细数据" />
      <div v-loading="tableLoading">
        <CustomTable
          v-if="hasUserInfo"
          class="product-report-detail-table"
          topic="product_detail"
          :args="downloadArgs"
          :dataSource="rawTableData"
          :customColumns="CustomColumns"
          :fixedColumns="fixedColumns"
          :columnDialogStyle="{width: '800px'}"
          :userInfo="userInfo"
          @created="handleCustomTableCreated"
          @download="handleCustomTableDownload"
          @change-columns="handleCustomTableColumnsChange"
          @sort-change="handleCustomTableSortChange"
          @filter-x-change="handleCustomTableFilterChange"
          @current-change="handleCustomTableCurrentChange"
          @size-change="handleCustomTableSizeChange"
        >
          <template v-slot:column="{ data: d }">
            <a
              v-if="d.field.key === 'product_name'"
              class="product-report-redirect"
              @click="handleProductNameClick(d.row)"
            >
              {{ d.value }}
            </a>

            <div v-else-if="checkIsHover(d.field.key, d)">
              <div v-if="dimensionBy === 'day'">
                <Tooltip>
                  <div
                    v-if="dimensionBy === 'day'"
                    slot="content"
                  >
                    <div>对比日期：{{ d.value.before_date }}</div>
                    <div>对比日期的值：{{ d.value.before_value }}</div>
                    <div>差值：{{ d.value.diff_value }}</div>
                  </div>
                  <div>
                    <span>{{ d.value.value }}</span>
                    <br>
                    <span :class="`product-report-${checkRate(d.value.rate)}`">
                      ({{ d.value.rate }})
                    </span>
                  </div>
                </Tooltip>
              </div>
              <div v-else>
                <div>
                  <span>{{ d.value.value }}</span>
                  <!-- <br>
                    <span :class="`product-report-${checkRate(d.value.rate)}`">
                      ({{ d.value.rate }})
                    </span> -->
                </div>
              </div>
            </div>


            <span v-else-if="d.field.key === 'sale_type'">{{ d.value === 1 ? '直投' : (d.value === 2 ? '渠道' : '') }}</span>
            <span v-else-if="d.field.key === 'customer_cate '">{{ d.value === 1 ? 'KA' : '非KA' }}</span>
            <span v-else>{{ d.value || '-' }}</span>
          </template>
        </CustomTable>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import {
  Tabs,
  TabPane,
  Select,
  Row,
  Col,
  Option,
  RadioGroup,
  RadioButton,
  Tooltip,
  Button,
} from 'element-ui';

import Title from '@/components/Title';
import DatePicker from '@/components/DatePicker2/Index';
import CustomTable from '@/components/CustomTableSort2/Index';
import StopDay from './components/StopDay/Index';
import Chart from './components/Chart/Index';

import { getFieldsByList } from '@/config/columns/';
import requestMixin from './mixins/request';
import {
  fields,
  customColumns,
  customColumns2, // 渠道使用
  customColumns3, // 直客或直客leader使用
  fixedColumns,
  fieldWithDiff,
} from './config/';
import { isEmpty } from '@/common/util';
import * as $cache from '@/common/cache';
import dateOptions from './config/date';
import Request from '@/core/QuRequest';
import queryGridByContainer from '@/common/js/queryGridByContainer';
const req = new Request();

const createDefaultDateRange = () => [
  moment().subtract(7, 'day'),
  moment().subtract(1, 'day'),
];
const DEFAULT_QUERY_ORDER = 'day desc';
const createDefaultFilterState = () => ({
  date: createDefaultDateRange(),
  dimension: 'day',
  dimensionBy: 'day',
  budget_ids: [],
  product_ids: [],
  sale_type: undefined,
  account_ids: [],
  agent_ids: [],
  user_sub_agent_ids: [],
  task_ids: [],
  sale_ids: [],
  customer_cate: undefined,
  product_series_ids: [],
  new_series_id: [],
  idea_type: undefined,
  plan_action_type: undefined,
  // slot_names: [],
  is_rta: undefined,
  charge_type: undefined,
  budget_ids_mode: 1,
  account_ids_mode: 1,
  agent_ids_mode: 1,
  user_sub_agent_ids_mode: 1,
  product_ids_mode: 1,
  sale_ids_mode: 1,
  product_series_ids_mode: 1,
  new_series_id_mode: 1,
  slot_names_mode: 1,
  task_ids_mode: 1,
});

export default {
  components: {
    Tabs,
    TabPane,
    Select,
    Row,
    Col,
    Option,
    RadioGroup,
    RadioButton,
    Tooltip,
    Button,
    DatePicker,
    StopDay,
    Title,
    Chart,
    CustomTable,
  },

  mixins: [requestMixin, queryGridByContainer],

  data() {
    return {
      // 查询时间段
      // 默认7天
      hourUseable: true,
      // date: [moment('2019-11-20'), moment('2019-11-23')],
      // 最后更新时间
      lastUpdateTime: '',
      // 当前指标
      field: 'cost_total',

      // 汇总信息
      summary: null,
      // 汇总信息 loading
      summaryLoading: true,
      // 停投天数
      // 默认为查询时间范围的差值
      stopDays: 5,
      // 是否显示停投天数对话框
      stopDayVisible: false,

      // 备选指标列表
      options: getFieldsByList(fields),
      // 汇总类型
      summaryType: 'all',
      // 图表数据 loading
      chartLoading: true,
      // 图表原始数据
      rawChartData: {},

      // 表格 loading
      tableLoading: true,
      // 当前页码
      page: 1,
      // 每页数量
      pageSize: 10,
      // 排序
      order: DEFAULT_QUERY_ORDER,
      // 过滤
      rawfilters: {},
      // 指标列表
      fields: [],
      // 固定列
      fixedColumns,
      // 表格原始数据
      rawTableData: {},
      dateOptions,
      budgetOptions: [
        { label: '直投', value: 1 },
        { label: '渠道', value: 2 },
      ],
      filterModeOptions: [
        { label: '选定', value: 1 },
        { label: '排除', value: 2 },
      ],
      kaOptions: [
        { value: 1, label: 'KA' },
        { value: 0, label: '非KA' },
      ],
      accountOptions: [],
      agentOptions: [],
      SubAccountOptions: [],
      subAccountSourceOptions: [],
      productSeriesOptions: [],
      productSeriesAllOptions: [],
      salesOptions: [],
      aggregationsOptions: [],
      productsOptions: [],
      ActionTypeOptions: [
        { label: '应用推广', value: 0 },
        { label: '线索收集', value: 1 },
        { label: '微信小程序', value: 2 },
        { label: '快应用', value: 4 },
        { label: '支付宝小程序', value: 5 },
      ],
      IdeaTypeOptions: [
        { label: '小图', value: 1 },
        { label: '大图', value: 2 },
        { label: '组图', value: 3 },
        { label: '视频广告（横版）', value: 4 },
        { label: '文字链广告', value: 6 },
        { label: '互动广告', value: 7 },
        { label: '开屏广告', value: 8 },
        { label: '横幅广告', value:9 },
        { label: '应用商城', value: 10 },
        { label: '视频广告（竖版）', value: 11 },
        { label: '激励视频', value: 12 },
        { label: '激励视频（信息流）', value: 15 },
        { label: '试玩广告', value: 16 },
        { label: '福利广告', value: 17 },
      ],
      slotNameOptions: [],
      slotNameSourceOptions: [],
      IsRtaOptions: [
        { label: '是', value: 1 },
        { label: '否', value: 0 },
      ],
      BidTypeOptions: [
        { label: 'CPC', value: 1 },
        { label: 'CPM', value: 2 },
        { label: 'oCPM', value: 3 },
        { label: '其他', value: 0 },
      ],
      ...createDefaultFilterState(),
      taskOptions: [],
      userInfo: {},
      queryExpanded: true,
    };
  },

  computed: {
    isZKOrZKLeader() {
      // 1:超管，2是直客销售  3是直客销售leader
      if(this.userInfo.role_ids) {
        return  this.userInfo.role_ids.includes("2") || this.userInfo.role_ids.includes("3")
      }
      return false
    },
    isChannelSale() {
      // 1:超管，2是直客销售  3是直客销售leader
      return Boolean(this.userInfo && this.userInfo.is_channel_sale);
    },
    hasUserInfo() {
      return this.userInfo && this.userInfo.is_channel_sale !== undefined;
    },
    CustomColumns() {
      return this.isChannelSale ? customColumns2 : ( this.isZKOrZKLeader ? customColumns3 : customColumns);
    },

    // 所选时间范围差
    dateDiff() {
      const [start, end] = this.date;
      const diff = moment(start).diff(moment(end), 'days');
      return Math.abs(diff) + 1;
    },

    // 图表数据是否为空
    isChartDataEmpty() {
      const { date, list } = this.rawChartData;
      return !(isEmpty(date) && isEmpty(list));
    },

    filters() {
      const arr = [];
      Object.keys(this.rawfilters).forEach((key) => {
        const { type, min, max } = this.rawfilters[key];
        arr.push(`${type},${min},${max}`);
      });
      return arr;
    },

    queryColumnsPerRow() {
      return Math.max(24 / this.queryColSpan, 1);
    },

    collapsedQueryCount() {
      return Math.min(
        Math.max(this.queryColumnsPerRow * 1 - 1, 1),
        this.queryFieldKeys.length,
      );
    },

    visibleQueryFieldCount() {
      return this.queryExpanded
        ? this.queryFieldKeys.length
        : this.collapsedQueryCount;
    },

    queryActionSpan() {
      // return this.queryColSpan
      const remainder = this.visibleQueryFieldCount % this.queryColumnsPerRow;
      const remainingColumns =
        remainder === 0
          ? this.queryColumnsPerRow
          : this.queryColumnsPerRow - remainder;

      return remainingColumns * this.queryColSpan;
    },

    queryFieldKeys() {
      if (this.isZKOrZKLeader) {
        return [
          'date',
          'budget_ids',
          'product_ids',
          'sale_type',
          'account_ids',
          'user_sub_agent_ids',
          'agent_ids',
          'sale_ids',
          'product_series_ids',
          'customer_cate',
          'task_ids',
          'plan_action_type',
          'idea_type',
          // 'slot_names',
          'is_rta',
          'charge_type',
          'dimension',
        ];
      }
      return [
        'date',
        'budget_ids',
        'product_ids',
        'sale_type',
        'account_ids',
        'user_sub_agent_ids',
        'agent_ids',
        'sale_ids',
        'product_series_ids',
        'new_series_id',
        'customer_cate',
        'task_ids',
        'plan_action_type',
        'idea_type',
        // 'slot_names',
        'is_rta',
        'charge_type',
        'dimension',
      ];
      
    },

    queryFieldVisibility() {
      const visibility = {};

      this.queryFieldKeys.forEach((key, index) => {
        visibility[key] = index < this.visibleQueryFieldCount;
      });

      return visibility;
    },

    showQueryToggle() {
      return this.queryFieldKeys.length > this.collapsedQueryCount;
    },

    downloadArgs() {
      const params = this.getParams();
      params.order_by = this.order;
      params.dimension = 'common';
      params.fields = [...this.fields]
        .join(',')
        .replace('direct_sale2', 'direct_sale');
      params.filters = this.filters;
      params._login_token = ($cache.localGet($cache.AUTH) || {}).token || '';
      params.sale_type = this.sale_type;
      Object.assign(params, this.getFilterParams());
      params.customer_cate = this.customer_cate;
      params.dimensionBy = this.dimensionBy;
      return params;
    },
  },
  watch: {
    date(n, o) {
      if (n && n.length === 2) {
        let startDate = moment(n[0]).format('YYYY-MM-DD');
        let endDate = moment(n[1]).format('YYYY-MM-DD');
        let flag = this.isDateRangeIncludeToday(startDate, endDate);

        if (this.dimension === 'hour' && !flag) {
          this.dimension = 'day';
          this.dimensionBy = 'day';
        }

        if (!flag) {
          this.hourUseable = false;
        } else {
          this.hourUseable = true;
        }
      }
    },
  },

  created() {
    // this.summaryLoading = false;
    // this.chartLoading = false;
    // this.tableLoading = false;
    // this.querySummaryData();
    this.queryChartData();
    this.queryProductSeriesList();
    this.queryProductSeriesListAll();
    this.queryAggregations('');
    this.queryProducts('');
    this.queryProductSales('');
    this.queryTasks('');
    this.getUserInfo();
  },

  methods: {
    async getUserInfo() {
      const res = await req.send(req.Apis.sales.user.userInfo);
      if (res.code === 200) {
        this.userInfo = res.data;
      }
    },
    isDateRangeIncludeToday(startDate, endDate) {
      const today = new Date();

      const start = new Date(startDate);
      const end = new Date(endDate);

      // 设置时间到午夜，避免时间部分的影响
      start.setHours(0, 0, 0, 0);
      end.setHours(23, 59, 59, 999);
      today.setHours(0, 0, 0, 0);

      return today >= start && today <= end;
    },
    handleSearchProducts(val) {
      this.queryProducts(val);
      // throttle(this.queryProducts(val), 500)
    },
    handleSearchAccounts(val) {
      this.queryAccounts(val);
    },
    handleSearchAgents(val) {
      this.queryAgents(val);
    },
    handleSearchSubAccounts(val) {
      this.querySubAccounts(val);
    },
    handleSearchAggregations(val) {
      this.queryAggregations(val);
      // throttle(this.queryAggregations(val), 500)
    },
    handleSearchSeries(val) {
      this.queryProductSeries(val);
      // throttle(this.queryProductSeries(val), 500)
    },
    handleSearchSeriesAll(val) {
      this.queryProductSeriesAll(val);
    },
    handleSearchSales(val) {
      this.queryProductSales(val);
      // throttle(this.queryProductSales(val), 500)
    },
    handleSearchTasks(val) {
      this.queryTasks(val);
    },
    handleSearchSlotNames(val) {
      this.querySlotNames(val);
    },
    toggleQueryExpand() {
      this.queryExpanded = !this.queryExpanded;
    },
    handleReset() {
      Object.assign(this, createDefaultFilterState(), {
        order: DEFAULT_QUERY_ORDER,
        page: 1,
        rawfilters: {},
      });
      // this.queryChartData();
      // this.queryTableData();
    },
    queryProductSeriesList() {
      this.queryProductSeries();
    },
    queryProductSeriesListAll() {
      this.queryProductSeriesAll();
    },
    handleAggregatedTypeChange(val) {
      this.dimensionBy = val;
    },
    // 修改查询时间段
    handleDatePickerChange() {
      // this.page = 1;
      // this.querySummaryData();
      // this.queryChartData();
      // this.queryTableData();
    },
    handleSearchData() {
      this.page = 1;
      // this.querySummaryData();
      this.queryChartData();
      this.queryTableData();
    },
    // 点击汇总卡片的设置按钮
    handleDataCardSettingClick() {
      this.stopDayVisible = true;
    },

    // 点击汇总卡片的蓝色数值
    handleDataCardNumClick(data) {
      this.dimension = data.key;
      this.handleTabsClick();
    },

    // 设置停投时间
    handleStopDayConfirm(day) {
      this.dimension = 'stop_product';
      this.queryStopProductSummary();
      this.handleTabsClick();
    },

    // 变更维度
    handleTabsClick() {
      this.page = 1;
      this.queryChartData();
      this.queryTableData();
    },

    // 变更指标
    handleFieldSelectChange() {
      this.queryChartData();
    },

    // 变更汇总类型
    handleSummaryTypeChange() {
      this.queryChartData();
    },

    // 表格下载
    handleCustomTableDownload() {
      this.download();
    },

    // 变更自定义列
    handleCustomTableColumnsChange(fields) {
      this.page = 1;
      this.fields = fields;
      this.queryTableData();
    },

    handleCustomTableCreated(fields) {
      this.page = 1;
      this.fields = fields;
      this.queryTableData();
    },

    // 点击产品名称
    handleProductNameClick(data) {
      const url = this.$router.resolve({
        path: '/product-report/exact-product',
        name: 'ProductReportExactProduct',
        query: {
          id: data.product_id,
          name: data.product_name,
          start: this.date[0].format('YYYY-MM-DD'),
          end: this.date[1].format('YYYY-MM-DD'),
        },
      });
      window.open(url.href, '_blank');
    },

    // 更改排序
    handleCustomTableSortChange(sort) {
      if (sort) {
        this.page = 1;
        this.order = sort;
        this.queryTableData();
      }
    },

    // 更改过滤
    handleCustomTableFilterChange(filter) {
      this.page = 1;
      const { type, min, max } = filter;
      if (min !== undefined && max !== undefined) {
        this.$set(this.rawfilters, type, filter);
      } else {
        this.$delete(this.rawfilters, type);
      }
      this.queryTableData();
    },

    // 更改页码
    handleCustomTableCurrentChange(current) {
      this.page = current;
      this.queryTableData();
    },

    // 更改每页数量
    handleCustomTableSizeChange(size) {
      this.pageSize = size;
      this.queryTableData();
    },

    // 当前单元格是否可以悬浮
    checkIsHover(key, d) {
      return fieldWithDiff.includes(key) && d.value;
    },

    // 判断是上涨还是下跌
    checkRate(rate) {
      return rate.indexOf('-') !== -1 ? 'bottom' : 'top';
    },

    // 查询汇总数据
    querySummaryData() {
      // this.summaryLoading = true;
      // this.querySummary();
    },

    // 查询折线图数据
    queryChartData() {
      this.chartLoading = true;
      if (this.summaryType === 'all') {
        this.queryMyPerformance();
      } else if (this.summaryType === 'top') {
        this.queryTopTen();
      }
    },

    // 查询表格数据
    queryTableData() {
      this.tableLoading = true;
      this.queryList();
    },
  },
};
</script>

<style lang="less" scoped>
.product-report {
  font-size: 14px;

  &-lastUpdateTime {
    color: #c0c4cc;
    margin-left: 16px;
  }

  &-summary {
    margin-top: 32px;
  }

  &-card {
    float: left;
    margin: 0 30px 30px 0;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &-chart {
    margin-top: 32px;
  }

  &-tabs {
    margin-top: 32px;

    &-header {
      display: flex;
      justify-content: space-between;
      margin: 10px 0 20px 0;
    }
  }

  &-detail {
    margin-top: 32px;

    &-table {
      margin-top: 32px;
    }
  }

  &-redirect {
    cursor: pointer;
    color: #2f9eff;
  }

  &-top {
    color: @crm-rise-color;
  }

  &-bottom {
    color: @crm-fall-color;
  }
}

.query-filter {
  display: flex;
  // gap: 8px;
  align-items: center;
  width: 100%;
}

.query-item {
  margin-bottom: 12px;
}

.query-item--actions {
  display: flex;
  align-items: flex-start;
}

.query-buttons {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
}

.query-toggle {
  padding: 0;
}

.query-filter__mode {
  width: 80px;
  flex-shrink: 0;
  // margin-right: -1px;
}

.query-filter__content {
  flex: 1;
  min-width: 0;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

/deep/ .query-filter__content.el-select .el-select__tags {
  flex-wrap: nowrap;
  overflow: hidden;
}

/deep/ .query-filter__content.el-select .el-tag {
  max-width: calc(100% - 8px);
  overflow: hidden;
}

/deep/ .query-filter__content.el-select .el-select__tags-text {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/deep/ .query-buttons .el-button + .el-button {
  margin-left: 0;
}

/deep/ .el-dialog {
  min-width: 800px;
}
</style>
